var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10658 2.55395C2.27196 2.22692 2.61204 2 3 2H19C19.388 2 19.728 2.22692 19.8934 2.55395L11 8.77934L2.10658 2.55395ZM5.14246e-05 2.98266C-0.000110751 2.99253 -0.000127099 3.00239 1.91283e-06 3.01225V15C1.91283e-06 16.6523 1.34772 18 3 18H19C20.6523 18 22 16.6523 22 15V3.01236C22.0001 3.00242 22.0001 2.99247 22 2.98251C21.9905 1.33822 20.6465 0 19 0H3C1.3535 0 0.00944232 1.3383 5.14246e-05 2.98266ZM20 4.92066V15C20 15.5477 19.5477 16 19 16H3C2.45229 16 2 15.5477 2 15V4.92066L10.4265 10.8192C10.7709 11.0603 11.2291 11.0603 11.5735 10.8192L20 4.92066Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputMail);
export default __webpack_public_path__ + "static/media/input_mail.465d66596c899eed8566b0fdfe0299f7.svg";
export { ForwardRef as ReactComponent };